import React from "react";

import { useHistory } from "react-router-dom";

// import { deleteJobDescriptions } from "../helperFunctions/dbFunctions";
import JobDescriptionCard from "./JobDescriptionCard";
import "../css/jobDescList.scss";
import { calcJobsTotalCost } from "../helperFunctions/calculationFunctions";

const JobDescList = ({
  timesheetId,
  jobDescriptions = [],
  dbRef,
  type,
  primaryData,
  inEditMode,
  isMarked,
  markItem,
  markedItems,
  vat,
  vatDiscrepancy,
}) => {
  // const {
  //   inEditMode,
  //   toggleEditMode,
  //   isMarked,
  //   markItem,
  //   markedItems,
  // } = useEditMode();
  const history = useHistory();
  const jds = jobDescriptions;

  let totalCost = calcJobsTotalCost(jobDescriptions, vat)[4];

  // function removeJobDescriptions() {
  //   deleteJobDescriptions(markedItems, timesheetId, dbRef);
  // }

  function pickJob(job) {
    if (inEditMode) {
      markItem(job);
    } else {
      if (type === "restore" || vatDiscrepancy) {
        return;
      }
      history.push(`/${type}/jobDescription/${job.uid}`, {
        timesheetId,
        jobDescription: job,
        type: type,
        totalCost: totalCost,
        primaryData,
      });
    }
  }

  return (
    <div className="jobDescList">
      <div className="section">
        <div>
          <h3 className="heading">Job Descriptions </h3>
          {/* <button onClick={toggleEditMode}>
            editMode {String(inEditMode)}
          </button> */}

          {/* This is a section showing the marked items?? */}
          {/* {markedItems.length > 0 ? (
            <button onClick={removeJobDescriptions}>Delete</button>
          ) : null} */}
          {/* {markedItems.map((j, i) => {
            console.log("j is", j);
            return <p key={i}>{j.uid}</p>;
          })} */}

          {/* ////////////////////////////////////////////// */}
        </div>

        {jds.length === 0 && <p className="noJobDescs">No Job Descriptions</p>}

        <div className={`jobCardList ${vatDiscrepancy ? "disabled" : ""}`}>
          {jds.map((jd) => {
            return <JobDescriptionCard isMarked={isMarked} job={jd} key={jd.uid} pickJob={pickJob} />;
          })}
        </div>
        {/* {jds.map((jd) => {
          return (
            <p
              style={
                isMarked(jd.uid)
                  ? { background: "red" }
                  : { background: "transparent" }
              }
              key={jd.uid}
              onClick={
                () => pickJob(jd)
                // history.push(`/${type}/jobDescription/${jd.uid}`, {
                //   timesheetId,
                //   jobDescription: jd,
                //   type: type
                // })
              }
            >
              jd:: {jd.hours}
            </p>
          );
        })} */}
      </div>
    </div>
  );
};

export default JobDescList;
